// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './assets/sass/main.scss'
import router from './routes'
import store from './store'
import VeeValidate, {Validator} from 'vee-validate'
import fr from 'vee-validate/dist/locale/fr'
import VueAffix from 'vue-affix'
import api from '@/api'

Validator.localize('fr', fr)

Validator.extend('unique_hospital', {
  getMessage (field, args) {
    return args[1] || 'Déjà reservé'
  },

  validate (value, args) {
    const [key] = args

    return api.checkIfHospitalExists({attr: key, value}).then(accountExists => {
      return !accountExists
    })
  }
})

Validator.extend('unique_account', {
  getMessage (field, args) {
    return args[1] || 'Ce numéro est déjà pris'
  },

  validate (value, args) {
    const [type] = args

    return api.checkIfAccountExists({type, phoneNumber: value}).then(accountExists => {
      return !accountExists
    })
  }
})

Vue.use(VeeValidate, {
  locale: 'fr',
  events: 'blur|input'
})

Vue.use(VueAffix)

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'development') {
  console.log('ENV API ', process.env.API_BASE_URL)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<router-view/>'
})



// WEBPACK FOOTER //
// /src/main.js